import { gql, useQuery } from '@apollo/client';
import { BrandKey } from '@prismamedia/one-brandkey';
import {
  GetArticleSourcesQuery,
  GetArticleSourcesQueryVariables,
} from '__generated__/queries-web';
import { getFilteredBrandKey } from 'utils/queries/variables';

export const GET_ARTICLE_SOURCES = gql`
  query GetArticleSources($where: SourceFilterInput) {
    sources(first: 100, where: $where, orderBy: title_ASC) {
      id
      title
    }
  }
`;

export const useGetSources = (brandKey: BrandKey | null) =>
  useQuery<GetArticleSourcesQuery, GetArticleSourcesQueryVariables>(
    GET_ARTICLE_SOURCES,
    {
      variables: { where: getFilteredBrandKey(brandKey) },
    },
  );
